import './_video.scss';

export default function Video() {
    const videoComponent = document.querySelectorAll('.video-content');

    if (videoComponent.length > 0) {
        videoComponent.forEach(item => {
            const video = item.querySelector('video') as HTMLVideoElement;
            const playBtn = item.querySelector('.play-btn') as HTMLElement;
            const $ytVideo = item.querySelector('.yt-video') as HTMLIFrameElement;

            if ($ytVideo) {
                const $videoCover = item.querySelector('.video-yt-cover') as HTMLElement;
                if ($videoCover && playBtn) {
                    $ytVideo.setAttribute('src', $ytVideo.src + '?enablejsapi=1');
                    window.addEventListener('load', () => {
                        playBtn.addEventListener('click', () => {
                            $videoCover.classList.add('d-none');
                            playBtn.classList.add('d-none');
                            $ytVideo.setAttribute('src', $ytVideo.src + '&autoplay=1');
                        });
                    });
                } else {
                    if (playBtn) {
                        playBtn.classList.add('d-none');
                    }
                }
            }

            if (video) {
                video.controls = false;

                playBtn.addEventListener('click', () => {
                    playBtn.classList.add('d-none');
                    video.play();
                    video.controls = true;
                });

                video.addEventListener('ended', () => {
                    playBtn.classList.remove('d-none');
                    video.controls = false;
                    video.load();
                });

                playBtn.addEventListener('keypress', function (e) {
                    if (e.code === 'Enter') {
                        video.play();
                        playBtn.classList.add('d-none');
                        video.controls = true;
                    }
                });

                function secondsConvert(secondsDuration: any) {
                    var m = Math.floor(secondsDuration / 60);
                    secondsDuration = Math.floor(secondsDuration % 60);
                    secondsDuration = secondsDuration >= 10 ? secondsDuration : '0' + secondsDuration;
                    return m + ':' + secondsDuration;
                }

                window.addEventListener('load', () => {
                    const videoDuration = item.querySelector('.time') as HTMLElement;

                    videoDuration.innerHTML = secondsConvert(video.duration);
                });
            }

            const transcription = item.querySelector('.transcription') as HTMLElement;
            const btnExpand = item.querySelector('.expand') as HTMLElement;
            const btnReduce = item.querySelector('.reduce') as HTMLElement;

            btnExpand &&
                btnExpand.addEventListener('click', () => {
                    btnExpand.classList.add('d-none');
                    btnReduce.classList.remove('d-none');
                    transcription.classList.add('full-text');
                });

            btnReduce &&
                btnReduce.addEventListener('click', () => {
                    btnReduce.classList.add('d-none');
                    btnExpand.classList.remove('d-none');
                    transcription.classList.remove('full-text');
                });

            btnExpand &&
                btnExpand.addEventListener('keypress', function (e) {
                    if (e.code === 'Enter') {
                        btnExpand.classList.add('d-none');
                        btnReduce.classList.remove('d-none');
                        transcription.classList.add('full-text');
                    }
                });

            btnReduce &&
                btnReduce.addEventListener('keypress', function (e) {
                    if (e.code === 'Enter') {
                        btnReduce.classList.add('d-none');
                        btnExpand.classList.remove('d-none');
                        transcription.classList.remove('full-text');
                    }
                });
        });
    }
}
